import { Grid, Link, List, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Project from '../components/Project';

const Dungeonland = () => {
    const list = [
        `Developed new Enemies + AI's;`,
        `Created new Spells for Players and Enemies;`,
        `Co-Developed the Procedural Map Generator;`,
        `New Cosmetic DLC packs;`,
    ];

    return (
        <Project>
            <Grid item xs={12}>
                <div className='aspect-ratio'>
                    <iframe
                        title='DungeonLand Trailer'
                        width='1904'
                        height='778'
                        src='https://www.youtube.com/embed/yxM9N1xOBqQ'
                        frameBorder='0'
                        allowFullScreen
                    ></iframe>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h1' component='h1'>
                    DungeonLand
                </Typography>
                <Typography variant='overline' display='block'>
                    Multiplayer co-op dungeon crawler MOBA
                </Typography>
                <br />
                <Typography gutterBottom>
                    I was one of the developers of one of the biggest brazilian
                    indie game studios, named Critical Studio. The game was
                    published by{' '}
                    <Link href='https://www.paradoxplaza.com/'>
                        Paradox Interactive
                    </Link>
                    . We shipped DungeonLand and hit Top 3 on Steam selling
                    list.
                </Typography>
                <br />
                <Typography>
                    <strong>Some of my tasks included:</strong>
                </Typography>
                <List>
                    {list.map((t, i) => (
                        <ListItemText key={`task-${i}`}>
                            &bull; {t}
                        </ListItemText>
                    ))}
                </List>
            </Grid>
        </Project>
    );
};

export default Dungeonland;
